export default __webpack_public_path__ + "static/media/tc-wlk-img.69c865a2.svg";